/* Character helpers: find a named bone for held items, and switch walk/idle clips from real movement. */

const BONE_ALIASES = {
 righthand: /right_?hand$/i, lefthand: /left_?hand$/i, head: /(^|[^a-z])head$/i,
 spine: /spine0?2$|spine2$|chest$/i, hips: /hips$|pelvis$/i, rightfoot: /right_?foot$/i, leftfoot: /left_?foot$/i
};

/** Bone under a model for an alias (rightHand, leftHand, head, spine, hips, rightFoot, leftFoot) or an exact bone name. */
export function findBone(object, name) {
 const bones = []; object.traverse(child => { if (child.isBone) bones.push(child); });
 const exact = bones.find(bone => bone.name === name); if (exact) return exact;
 const alias = BONE_ALIASES[String(name).toLowerCase().replace(/[^a-z]/g, '')];
 const clean = bone => bone.name.replace(/^mixamorig:?/i, '');
 return alias ? bones.find(bone => alias.test(clean(bone))) || null : bones.find(bone => clean(bone).toLowerCase() === String(name).toLowerCase()) || null;
}
export function boneNames(object) { const names = []; object.traverse(child => { if (child.isBone) names.push(child.name); }); return names; }

/** Walk while moving, idle (or stand on the first frame) while still. */
export function createLocomotion(THREE, mixer, clips, animation) {
 const find = name => name ? clips.find(clip => clip.name === name) : null;
 const move = find(animation.moveClip), idle = find(animation.idleClip),run=find(animation.runClip),jump=find(animation.jumpClip),swim=find(animation.swimClip);
 if (!move && !idle && !run && !jump && !swim) return null;
 const actions = { move: move ? mixer.clipAction(move) : null, idle: idle ? mixer.clipAction(idle) : null,run:run?mixer.clipAction(run):null,jump:jump?mixer.clipAction(jump):null,swim:swim?mixer.clipAction(swim):null };
 const last = new THREE.Vector3(), now = new THREE.Vector3(); let moving = null, started = false, speed = 0;
 function set(next) {
  if (next === moving) return;const previous=moving; moving = next;
  const on=actions[next],off=actions[previous];
  if (on) { on.enabled = true; on.paused = false; on.setEffectiveTimeScale(animation.speed ?? 1); on.setEffectiveWeight(1); on.reset().play(); if (off && off.isRunning()) on.crossFadeFrom(off, animation.blendTime??.25, false); }
  else { mixer.stopAllAction(); } // No idle clip: restore the imported standing pose.
 }
 return {
  update(object, dt) {
   object.getWorldPosition(now);
   if (!started) { started = true; last.copy(now); set('idle'); return; }
   if (dt > 0) { const v = Math.hypot(now.x - last.x, now.z - last.z) / dt; speed += (v - speed) * Math.min(1, dt * 8); }
   last.copy(now);const active=moving==='move'||moving==='run';set(object.userData.motionState==='swim'&&actions.swim?'swim':object.userData.motionState==='jump'&&actions.jump?'jump':speed>(active ? .2 : .35)?(actions.run&&(!actions.move||speed>=(animation.runThreshold??3.5))?'run':'move'):'idle');
  },
  get moving() { return moving==='move'||moving==='run'; }
 };
}

